import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import {
  getRebates as getRebatesApi,
  getRebatesPNL as getRebatesPNLApi,
} from "../../helpers/ServiceHelpers/backend_helper";

export const getRebates = createAsyncThunk(
  "rebates/getRebates",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getRebatesApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getRebatesPNL = createAsyncThunk(
  "rebates/getRebatesPNL",
  async (params: any) => {
    const { id, data } = params;
    try {
      const response = getRebatesPNLApi(id, data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
